import React from "react";
import { components } from "react-select";
import { Tooltip } from "react-tooltip";

const SearchMatchOption = (props) => {
  const tooltipId = `${props.innerProps.id}-description`;

  return (
    <>
      <components.Option
        {...props}
        innerProps={{
          ...props.innerProps,
          role: "option",
          "aria-selected": props.isSelected,
          "aria-describedby": tooltipId,
          "data-tooltip-id": tooltipId,
        }}
      />
      <Tooltip
        id={tooltipId}
        anchorSelect={`[id="${props.innerProps.id}"]`}
        isOpen={props.isFocused}
        place={props.data.tooltipLanguage === "ar" ? "right" : "left"}
        positionStrategy="fixed"
        className="search-match-tooltip"
      >
        <span dir={props.data.tooltipLanguage === "ar" ? "rtl" : "ltr"}>
          <strong>{props.data.description}</strong>{" "}
          {props.data.guidance}
        </span>
      </Tooltip>
    </>
  );
};

export default SearchMatchOption;
